/* eslint-disable */

/*
 * This is a generated file created by deere-ui-svg-to-react.
 *
 * Please do not modify this file directly as it will be regenerated at build time.
 */

"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

exports["default"] = _react2["default"].createClass({
    displayName: "void",

    getDefaultProps: function getDefaultProps() {
        return {
            "st0": {
                "fill": "#BD2E28"
            },
            "void": {
                "backgroundImage": "none",
                "backgroundPosition": "0% 0%",
                "display": "inline",
                "fill": "#333"
            },
            "width": "18.3",
            "height": "18.3"
        };
    },

    render: function render() {
        return _react2["default"].createElement(
            "svg",
            { id: "Layer_1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 18.3 18.3", className: "void", width: this.props.width, height: this.props.height, style: this.props["void"] },
            _react2["default"].createElement("path", { className: "st0", d: "M9.2 0C4.1 0 0 4.1 0 9.2s4.1 9.2 9.2 9.2 9.2-4.1 9.2-9.2S14.2 0 9.2 0zm0 2.1c1.7 0 3.2.6 4.4 1.5l-9.9 9.9c-1-1.2-1.5-2.7-1.5-4.4-.1-3.8 3.1-7 7-7zm0 14.1c-1.5 0-3-.5-4.1-1.3L14.9 5c.8 1.2 1.3 2.6 1.3 4.1 0 4-3.1 7.1-7 7.1z", style: this.props.st0 })
        );
    }
});

/* eslint-enable */
module.exports = exports["default"];



// WEBPACK FOOTER //
// ./~/cap-it-ui.toggles/~/cap-it-ui.icons/lib/void.js